import React from "react";
import { useModal } from "hooks/Modal";

export default function ModalButtons() {
    const { setOpen, state } = useModal();

    return (
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
                disabled={state.disabled === true}
                onClick={() =>
                    state.onRequestClose
                        ? state.onRequestClose(setOpen.bind(null, false))
                        : setOpen(false)
                }
            >
                {state.confirmText ? state.confirmText : "OK"}
            </button>
            <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={() => setOpen(false)}
                ref={state.cancelButtonRef}
            >
                {state.cancelText ? state.cancelText : "Cancel"}
            </button>
        </div>
    );
}
